"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAssetReset extends new_item_1.default {
    constructor(newAssetReset) {
        super();
        this.assetId = newAssetReset.assetId;
        this.timestamp = newAssetReset.timestamp;
        this.value = newAssetReset.value;
        this.start = newAssetReset.start;
        this.end = newAssetReset.end;
    }
}
exports.default = NewAssetReset;
//# sourceMappingURL=new-assetReset.js.map